/* デニム KV スライダー
   data-denim-kv 属性が付いた要素を全部拾って、子の .denim-kv__slide を
   data-slide-speed (秒) ごとにローテーション。
   slide 数 < 2 の KV は何もしない。 */
(function () {
  document.querySelectorAll('[data-denim-kv]').forEach(function (kv) {
    var slides = kv.querySelectorAll('.denim-kv__slide');
    if (slides.length < 2) return;
    var dots = kv.querySelectorAll('[data-denim-kv-dot]');
    var speed = parseInt(kv.dataset.slideSpeed, 10) * 1000;
    if (!speed || speed < 500) return;
    var current = 0;

    function showSlide(next) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('is-active');
      dots[current]?.removeAttribute('aria-current');
      current = next;
      slides[current].classList.add('active');
      dots[current]?.classList.add('is-active');
      dots[current]?.setAttribute('aria-current', 'true');
    }

    var timer = setInterval(function () {
      showSlide((current + 1) % slides.length);
    }, speed);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.dataset.denimKvDot, 10));
        clearInterval(timer);
        timer = setInterval(function () {
          showSlide((current + 1) % slides.length);
        }, speed);
      });
    });
  });
})();
